<div class="left-panel-container">
  <div class="top-container">
    <tlc-churn-flow-tellent-logo />
    @if (currentStep() && !reasonInfoboxMessage()) {
      <tlc-churn-flow-step-counter
        [currentStep]="currentStep()!"
        [numberOfSteps]="numberOfSteps"
        [label]="
          'tlc.churn_flow.common.step_counter'
            | translate: { current: currentStep(), total: numberOfSteps }
        "
      />
    }
  </div>
  @if (reasonInfoboxMessage()) {
    <rt-infobox type="information" iconName="info-outline" [isDismissible]="false" margin-top-large>
      <span [innerHTML]="reasonInfoboxMessage()"></span>
    </rt-infobox>
  }
  <div class="content-container" [class.infobox-displayed]="reasonInfoboxMessage()">
    <ng-content select=".left" />
  </div>
</div>

<div class="right-panel-container">
  <div class="background-container" [class]="rightPanelBackgroundVariant()">
    <ng-content select=".right" />
  </div>
</div>
